const colors = {
    white: '#ffffff',
    black: '#303030',
    green: '#539137',
    orange: '#f8972b',
    orangeLightest: '#ffefd5',
    blue: '#0a88c5',
    red: '#ce1300',
    gray: '#dadada',
    lightGray: '#cccccc',
    lighterGray: '#808080',
    lightestGray: '#f8f8f8',
    darkGray: '#aaaaaa',
    silverLight: '#eeeeee',
    silverLighter: '#f5f5f5',
    silverDark: '#cccccc',
    silverDefault: '#dadada',
};

export default colors;
